module.exports = __webpack_public_path__ + "static/media/copy.4475d9ae.svg";